// extracted by mini-css-extract-plugin
export default {"notification-box":"style_notification-box__FPUY6","toast-notification":"style_toast-notification__nDNet"};